import { useI18n } from 'vue-i18n';

export default function usePropertyWhitelist() {
  const { locale } = useI18n();

  const propertyWhitelist: Record<string, number[]> = {
    de: [1, 2, 4, 6, 7, 8, 9, 12, 18, 66, 70, 71],
    dk: [1, 6, 2, 7, 8, 9],
    nl: [1, 6, 2, 7, 8, 9],
  };

  const getWhitelist = () => {
    const currentCountry = locale.value;
    return propertyWhitelist[currentCountry] || [];
  };

  const filterProperties = (groups: { id: number, properties: number[] }[]) => {
    const whitelist = getWhitelist();
    return groups.map(group => ({
      ...group,
      properties: group.properties.filter(property => whitelist.includes(property))
    })).filter(group => group.properties.length > 0);
  };

  return {
    getWhitelist,
    filterProperties,
  };
}
